export default __webpack_public_path__ + "static/media/icon-info.121cc293.svg";